import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "query()",
  "order": 541
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Hint = makeShortcode("Hint");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A request handler that captures a GraphQL query by the given name.`}</p>
    <Hint mode="warning" mdxType="Hint">
  This request handler captures GraphQL queries regardless of their endpoint.
  See{' '}
  <a href="/docs/api/graphql/link">
    <code>graphql.link()</code>
  </a>{' '}
  for the endpoint-based mocking.
    </Hint>
    <h2 {...{
      "id": "call-signature"
    }}>{`Call signature`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface graphql {
  query<QueryType, VariablesType>(
    name: string | RegExp,
    resolver: ResponseResolver,
  ): RequestHandler
}
`}</code></pre>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "basic-query"
    }}>{`Basic query`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`query GetAllUsers {
  users {
    firstName
    lastName
  }
}
`}</code></pre>
    <p>{`To capture a GraphQL query provide its name as the first argument to the `}<inlineCode parentName="p">{`graphql.query()`}</inlineCode>{` request handler. Using the query definition above, the request handler for it would look as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { graphql } from 'msw'

graphql.query('GetAllUsers', (req, res, ctx) => {
  return res(
    ctx.data({
      users: [
        {
          firstName: 'John',
          lastName: 'Maverick',
        },
        {
          firstName: 'Cathaline',
          lastName: 'McCoy',
        },
      ],
    }),
  )
})
`}</code></pre>
    <h3 {...{
      "id": "query-variables"
    }}>{`Query variables`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-graphql",
        "metastring": "focusedLines=1",
        "focusedLines": "1"
      }}>{`query GetSingleUser($id: ID!) {
  user(id: $id) {
    firstName
    lastName
  }
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Variables must be correctly defined in the GraphQL query definition in order to be accessible in mocks. Refer to the `}<a parentName="p" {...{
          "href": "https://graphql.org/learn/queries/#variables"
        }}>{`GraphQL Variables`}</a>{` for more information.`}</p>
    </blockquote>
    <p>{`Use `}<inlineCode parentName="p">{`req.variables`}</inlineCode>{` object to access all the variables of the captured query.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "focusedLines=2",
        "focusedLines": "2"
      }}>{`graphql.query('GetSingleUser', (req, res, ctx) => {
  const { id } = req.variables

  return res(
    ctx.data({
      user: {
        id,
        firstName: 'John',
        lastName: 'Maverick',
      },
    }),
  )
})
`}</code></pre>
    <h3 {...{
      "id": "dynamic-query-name"
    }}>{`Dynamic query name`}</h3>
    <p>{`When given a `}<inlineCode parentName="p">{`RegExp`}</inlineCode>{` as the query name, all the GraphQL queries that match that expression would be captured by this request handler.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`query GetUserDetail {
  user {
    firstName
    lastName
  }
}

query GetCartDetail {
  cart {
    id
    items {
      price
    }
  }
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "focusedLines=3",
        "focusedLines": "3"
      }}>{`import { graphql } from 'msw'

graphql.query(/^Get(.+?)Detail$/, (req, res, ctx) => {
  return res(
    ctx.errors([
      {
        message: 'Not authorized',
      },
    ]),
  )
})
`}</code></pre>
    <h3 {...{
      "id": "usage-with-typescript"
    }}>{`Usage with TypeScript`}</h3>
    <p>{`Annotate your queries in TypeScript to get autocompletion and validation for query data and variables in your IDE.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts",
        "metastring": "focusedLines=3-8,10-12,14",
        "focusedLines": "3-8,10-12,14"
      }}>{`import { graphql } from 'msw'

interface GetUserQuery {
  user: {
    firstName: string
    lastName: string
  }
}

interface GetUserQueryVariables {
  id: string
}

graphql.query<GetUserQuery, GetUserQueryVariables>(
  'GetUser',
  (req, res, ctx) => {
    const { id } = req.variables

    return res(
      ctx.data({
        user: {
          firstName: 'John',
          lastName: 'Maverick',
        },
      }),
    )
  },
)
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Consider tools like `}<a parentName="p" {...{
          "href": "https://graphql-code-generator.com/"
        }}>{`GraphQL Code Generator`}</a>{` to annotate your mocks with the type definitions derived from the actual GraphQL schema.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      